import React from 'react';
import { HeroSection } from './HeroSection';
import { PainSection } from './PainSection';
import { OldSolutionsSection } from './OldSolutionsSection';
import { RealProblemSection } from './RealProblemSection';
import { ProtocolSection } from './ProtocolSection';
import { PromisesSection } from './PromisesSection';
import { WhatsInsideSection } from './WhatsInsideSection';
import { ForWhoSection } from './ForWhoSection';
import { FinalCloseSection } from './FinalCloseSection';
import { Footer } from './Footer';
export function SalesPage() {
  return <div className="min-h-screen bg-[#0D0D0D] text-[#F5F0EB] selection:bg-[#A52422] selection:text-white" data-id="element-189">
      <HeroSection data-id="element-190" />
      <PainSection data-id="element-191" />
      <OldSolutionsSection data-id="element-192" />
      <RealProblemSection data-id="element-193" />
      <ProtocolSection data-id="element-194" />
      <PromisesSection data-id="element-195" />
      <WhatsInsideSection data-id="element-196" />
      <ForWhoSection data-id="element-197" />
      <FinalCloseSection data-id="element-198" />
      <Footer data-id="element-199" />
    </div>;
}